import React from 'react'
import Header from '../components/Header/Header'
import View from '../components/View/View'

function ViewPage() {
    return (
        <div>
            <Header />
            <View />
        </div>
    )
}

export default ViewPage
